var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import paper from 'paper';
var NeuralaProject = /** @class */ (function (_super) {
    __extends(NeuralaProject, _super);
    function NeuralaProject(params) {
        var _this = _super.call(this, params) || this;
        _this.polygonResizingInProgress = false;
        _this.polygonMovingInProgress = false;
        return _this;
    }
    NeuralaProject.prototype.getAsset = function () {
        return this.layers['assetLayer'] ? this.layers['assetLayer'].children[0] : null;
    };
    NeuralaProject.prototype.getAssetBounds = function () {
        return this.layers['assetLayer']
            ? this.layers['assetLayer'].bounds
            : new paper.Rectangle(new paper.Point(0, 0), new paper.Size(0, 0));
    };
    return NeuralaProject;
}(paper.Project));
export { NeuralaProject };
//# sourceMappingURL=project.js.map


// WEBPACK FOOTER //
// ./src/components/workspace/objects/project.ts.pre-build-optimizer.js